export const defaultCustomData = (campaign) => campaign.businessType === 'CUSTOM' ? {} : campaign.businessType === 'POST'
    ? { type: 'POST', id: campaign.targetParams?.id || '' }
    : campaign.businessType === 'PICK' ? { type: 'INVESTMENT_IDEA', id: campaign.targetParams?.id || '' }
        : { type: 'TICKER', ticker: campaign.targetParams?.ticker || '' };

export const customDataValues = (campaign) => campaign.customData != null ? (campaign.customData.values || {}) : defaultCustomData(campaign);
export const customDataRows = (campaign) => campaign.customDataRows ?? Object.entries(customDataValues(campaign)).map(([key, value]) => ({ key, value }));
export const customDataFromRows = (rows) => ({ values: Object.fromEntries(rows.filter((row) => row.key).map(({ key, value }) => [key, value])) });

export function customDataError(rows) {
    const seen = new Set();
    for (const { key, value } of rows) {
        if (!key.trim() || key.trim() !== key) return '参数名不能为空或包含首尾空格，请填写或删除该行。';
        if (seen.has(key)) return `参数名 ${key} 重复，请修改或删除重复行。`;
        if (['from', 'message_type', 'gcm', 'campaign_id', 'message_id', 'content_locale'].includes(key) || /^(google\.|gcm\.)/.test(key)) return `${key} 是系统保留参数，不能自定义。`;
        if (typeof value !== 'string') return '参数值必须是文本。';
        seen.add(key);
    }
    return '';
}

export function customDataTargetError(values, businessType) {
    if (businessType === 'CUSTOM') return '';
    if (businessType === 'PICK' && values.type !== 'INVESTMENT_IDEA') return 'Pick 详情需要 type 为 INVESTMENT_IDEA，请重新填写 Pick ID。';
    if (values.type === 'INVESTMENT_IDEA') return /^[1-9]\d*$/.test(values.id || '') ? '' : '附加参数 type 为 INVESTMENT_IDEA 时，请填写有效的 Pick id。';
    if (values.type === 'POST') return /^[1-9]\d*$/.test(values.id || '') ? '' : '附加参数 type 为 POST 时，请填写有效的文章 id。';
    if (values.type === 'TICKER') return values.ticker?.trim() ? '' : '附加参数 type 为 TICKER 时，请填写 ticker。';
    return '附加参数 type 必须为 POST、TICKER 或 INVESTMENT_IDEA。';
}

// Choosing a new target refreshes routing fields while retaining unrelated data.
export function withCustomDataTarget(campaign, businessType, targetParams) {
    const next = { ...campaign, businessType, targetParams };
    const routing = defaultCustomData(next);
    const rows = customDataRows(campaign).filter(({ key }) => !['type', 'id', 'ticker'].includes(key));
    next.customDataRows = [...Object.entries(routing).map(([key, value]) => ({ key, value })), ...rows];
    next.customData = customDataFromRows(next.customDataRows);
    return next;
}
